var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAboutIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "About-icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 67.166,
    height: 67.166,
    viewBox: "0 0 67.166 67.166",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_392",
    "data-name": "Path 392",
    d: "M38.083,43.68H10.1a5.6,5.6,0,0,1-5.6-5.6V10.1a5.6,5.6,0,0,1,5.6-5.6H38.083a5.6,5.6,0,0,1,5.6,5.6V38.083A5.6,5.6,0,0,1,38.083,43.68ZM10.1,10.1V38.083H38.083V10.1Z",
    transform: "translate(-4.5 -4.5)",
    fill: "#0072ce"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_393",
    "data-name": "Path 393",
    d: "M39.291,16.847V28.041H28.1V16.847H39.291m0-5.6H28.1a5.6,5.6,0,0,0-5.6,5.6V28.041a5.6,5.6,0,0,0,5.6,5.6H39.291a5.6,5.6,0,0,0,5.6-5.6V16.847A5.6,5.6,0,0,0,39.291,11.25Z",
    transform: "translate(22.277 5.541)",
    fill: "#0072ce"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_394",
    "data-name": "Path 394",
    d: "M39.291,28.1V39.291H28.1V28.1H39.291m0-5.6H28.1a5.6,5.6,0,0,0-5.6,5.6V39.291a5.6,5.6,0,0,0,5.6,5.6H39.291a5.6,5.6,0,0,0,5.6-5.6V28.1A5.6,5.6,0,0,0,39.291,22.5Z",
    transform: "translate(22.277 22.277)",
    fill: "#0072ce"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_395",
    "data-name": "Path 395",
    d: "M28.041,28.1V39.291H16.847V28.1H28.041m0-5.6H16.847a5.6,5.6,0,0,0-5.6,5.6V39.291a5.6,5.6,0,0,0,5.6,5.6H28.041a5.6,5.6,0,0,0,5.6-5.6V28.1A5.6,5.6,0,0,0,28.041,22.5Z",
    transform: "translate(5.541 22.277)",
    fill: "#0072ce"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutIcon);
export default __webpack_public_path__ + "static/media/About-icon.c0ab36099e3725c2f5524b0fa2a3fcd0.svg";
export { ForwardRef as ReactComponent };